
<script>
import { Radar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
//reactiveProp extends the logic of your chart component and automatically creates a prop named chartData and adds a vue watch on this prop. 
//On data mutation, it will call update() if the data inside the datasets has changed, or renderChart() if new datasets were added. see vue-chartjs documentation


export default {
    extends: Radar,
    mixins: [reactiveProp],
    prop: {},
    data() {
        const vm = this;
        return {
            chartOptions: {
                legend:{
                    display: false,
                },
                scale: {
                    pointLabels: {
                        fontSize: 16
                    }
                },
                tooltips:{
                    callbacks:{
                        title: (tooltipItem, chartData) => {
                            if (chartData.description != null) {                                
                                return chartData.labels[tooltipItem[0].index] + ': ' + vm.questionKeywords[tooltipItem[0].index];
                            }
                            return chartData.labels[tooltipItem[0].index]                                                                                                            
                        },
                    }
                }
            },
            questionKeywords: null                            
        };
    },
    mounted() {
        this.renderChart(this.chartData, this.chartOptions);
        this.questionKeywords = this.chartData.description;
    },
    methods: {
        updateChart(dataIndex){
            const isDataShown = this.$data._chart.isDatasetVisible(dataIndex);
            console.log('is data shown ' + isDataShown);
            if(isDataShown == false){
                this.chartData.datasets[dataIndex].hidden = false;
                this.renderChart(this.chartData, this.chartOptions);

            }
            else{
                console.log("Data is shown");
                this.chartData.datasets[dataIndex].hidden = true;
                this.renderChart(this.chartData, this.chartOptions);

            }
        }      
    },
    watch:{
        chartData: {handler(newValue, oldValue) {
            this.questionKeywords = (newValue.description);
        },
        deep: true},
    }
};
</script>
